var AddressLineFormat = /* @__PURE__ */ ((AddressLineFormat2) => {
  AddressLineFormat2["streetName_streetNumber"] = "streetName_streetNumber";
  AddressLineFormat2["streetNumber_streetName"] = "streetNumber_streetName";
  return AddressLineFormat2;
})(AddressLineFormat || {});
export {
  AddressLineFormat
};
//# sourceMappingURL=checkout-settings.js.map
